module.exports = __webpack_public_path__ + "static/triangle_background1-565c33125c4aa93d2e467490bb380d5a.jpg";